import { Component, OnInit, OnDestroy, Input } from "@angular/core";
import { Router } from "@angular/router";
import { StoreService } from "../../services";
import { LocalService } from "../../services/local.service";
import { CONSTANTS } from "../../../config";
import { Subscription } from "rxjs";
import { isPamUser, isProfileComplete, filterUserRoles } from "src/app/shared/utils/user.util";

@Component({
  selector: "cisco-steer-logo",
  templateUrl: "./logo.component.html",
  styleUrls: ["./logo.component.scss"],
})
export class LogoComponent implements OnInit, OnDestroy {
  @Input() userData: any;

  managerFlag: boolean = false;
  sellerFlag: boolean = false;

  private userDataSubscription: Subscription | null = null;

  constructor(
    private router: Router,
    private storeService: StoreService
  ) {}

  ngOnInit(): void {
    if (!this.userData) {
      this.loadUserData();
    } else {
      this.setFlags();
    }
  }

  ngOnDestroy(): void {
    if (this.userDataSubscription) {
      this.userDataSubscription.unsubscribe();
    }
  }

  private loadUserData(): void {
    this.userDataSubscription = this.storeService.getUserObj().subscribe((res: any) => {
      if (res) {
        this.userData = res;
        this.setFlags();
      }
    });

    const cachedUserData = LocalService.get("userProfile");
    if (cachedUserData) {
      this.userData = cachedUserData;
      this.setFlags();
    }
  }

  setFlags(): void {
    if (isProfileComplete(this.userData)) {
      if (isPamUser(this.userData)) {
        this.managerFlag = true;
      } else {
        this.managerFlag = filterUserRoles(this.userData, CONSTANTS.manager).length > 0;
        this.sellerFlag = filterUserRoles(this.userData, CONSTANTS.seller).length > 0;
      }
    }
  }

  goHome(): void {
    if (this.managerFlag) {
      this.router.navigateByUrl("/home/manager/manage-challenges");
    } else if (this.sellerFlag) {
      this.router.navigateByUrl("/home/seller/challenges");
    } else if (this.userData && this.userData.id) {
      this.router.navigateByUrl("/home");
    } else {
      this.router.navigateByUrl("/profile");
    }
  }
}
